import type { OurFileRouter } from "@teamz/api/uploadthing";

import { generateUploadButton } from "@uploadthing/react";

import { env } from "@/env";

// The uploadthing client doesn't send cookies cross-origin, so the API's Clerk
// middleware would see no auth. Inject the same bearer token the tRPC client
// sends, once at the factory level, so every UploadButton request is
// authenticated by construction. The app renders under <ClerkLoaded>, so
// window.Clerk is set.
type ClerkGlobal = { session?: { getToken: () => Promise<string | null> } | null };

const fetchWithClerkToken: typeof fetch = async (input, init) => {
  const clerk = (globalThis as { Clerk?: ClerkGlobal }).Clerk;
  let token: string | null = null;
  try {
    token = await clerk?.session?.getToken() ?? null;
  }
  catch {
    // Let the API return an explicit unauthorized response.
  }

  const headers = new Headers(init?.headers);
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(input, { ...init, headers });
};

export const UploadButton = generateUploadButton<OurFileRouter>({
  // This is the URL that the upload button will send the file to
  url: `${env.API_URL}/uploadthing`,
  fetch: fetchWithClerkToken,
});
